import { render, staticRenderFns } from "./SurfaceTitleDescription.vue?vue&type=template&id=18773572&scoped=true&"
import script from "./SurfaceTitleDescription.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SurfaceTitleDescription.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SurfaceTitleDescription.vue?vue&type=style&index=0&id=18773572&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18773572",
  null
  
)

export default component.exports